import { Input, Label } from "@tsi/ui";

export const MINIMO_SENHA = 8;

/** Nova senha + confirmação, com a regra visível. Devolve o erro a mostrar (ou null). */
export function validarSenhaNova(nova: string, confirmacao: string): string | null {
  if (nova.length < MINIMO_SENHA) return `A senha precisa ter pelo menos ${MINIMO_SENHA} caracteres.`;
  if (nova !== confirmacao) return "As duas senhas não são iguais.";
  return null;
}

export function CampoSenhaNova(props: { nova: string; confirmacao: string; onNova: (v: string) => void; onConfirmacao: (v: string) => void }) {
  return (
    <>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="nova">Nova senha</Label>
        <Input id="nova" type="password" autoComplete="new-password" value={props.nova} onChange={(e) => props.onNova(e.target.value)} required />
        <span className="text-xs text-muted-foreground">Mínimo de {MINIMO_SENHA} caracteres.</span>
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="confirmacao">Repita a nova senha</Label>
        <Input
          id="confirmacao"
          type="password"
          autoComplete="new-password"
          value={props.confirmacao}
          onChange={(e) => props.onConfirmacao(e.target.value)}
          required
        />
      </div>
    </>
  );
}
